import axios from 'axios'
import { AnimatePresence, motion } from 'framer-motion'
import { useEffect, useRef, useState } from 'react'
import { GrAdd, GrFormAdd } from 'react-icons/gr'
import { HiOutlineDocumentAdd } from 'react-icons/hi'
import { IoMdAdd } from 'react-icons/io'
import { useOutsideClick } from '../../utils/hooks'
import Tooltip from '../Display/Tooltip'
const server = process.env.REACT_APP_SERVER_URL

const FieldArrayAutocomplete: React.FC<FieldAutocompleteProps> = ({
  url,
  bodyGet,
  queryParam,
  valuesToCompare = [],
  edit = {},
  onChangeValue,
  useCase,
  queryParamsId,
  isFromAddProduct = false,
  secondUrl,
  secondQueryParam,
  bodyGetSecond,
}) => {
  const [showValues, setShowValues] = useState<boolean>(false)

  const [arrayOfValues, setArrayOfValues] = useState<any[]>([])

  const [selectedValue, setSelectedValue] = useState<any | null>(null)

  const [showAmountError, setShowAmountError] = useState<boolean>(false)

  const [valueExist] = useState<boolean>(false)

  const [alreadyDone, setAlreadyDone] = useState<boolean>(false)

  const myRef = useRef<HTMLInputElement | null>(null)

  const myrefAmount = useRef<HTMLInputElement | null>(null)

  const myContainerRef = useRef<HTMLDivElement | null>(null)

  useOutsideClick(myContainerRef, () => setShowValues(false))

  let values = {
    '0': (value) =>
      useCase === 'UNLOAD'
        ? `?idWarehouse=${queryParamsId}&${queryParam}=${value}`
        : `${isFromAddProduct ? '&' : '?'}${queryParam}=${value}`,
    '1': () => (useCase === 'UNLOAD' ? `?idWarehouse=${queryParamsId}` : ``),
  }

  const getItems = async (value: string = ''): Promise<void> => {
    let respSecond
    let arrayOfValues : any[] = []
    try {
      let resp = await axios.get(
        `${server}/${url}${values[+(value === '')](value)}`
      )

      arrayOfValues = resp.data[bodyGet].filter(  
        (v) => !valuesToCompare.some((x) => x?.idItem === v.id)
      )?.map(v => ({...v, type: 'PRODUCT'}))


      if (secondUrl && secondQueryParam && bodyGetSecond) {
        respSecond = await axios.get(
          `${server}/${secondUrl}${values[+(value === '')](value)}`
        )
        arrayOfValues = [...arrayOfValues, ...respSecond.data[bodyGetSecond].filter(
          (v) => !valuesToCompare.some((x) => x?.idItem === v.id)
        )?.map(v => ({...v, type: 'SERVICE'}))]
      }

      useCase === 'UNLOAD'
        ? setArrayOfValues(
            arrayOfValues
          )
        : useCase === 'COMPOSITION'
        ? setArrayOfValues(
            arrayOfValues
          )
        : useCase === 'LOAD'
        ? setArrayOfValues(
            arrayOfValues
          )
        : useCase === 'ASSEMBLY'
        ? setArrayOfValues(
            arrayOfValues
          )
        : useCase === 'RAW_MATERIAL'
        ? setArrayOfValues(
            arrayOfValues
          )
        : setArrayOfValues(
            resp.data[bodyGet]
              .map((v) => ({ ...v.item, quantity: v.quantity }))
              .filter((v) => !valuesToCompare.some((x) => x.idItem === v.id))
          )
    } catch (e: any) {
    } finally {
      setAlreadyDone(true)
    }
  }

  useEffect(() => {
    getItems()
  }, [valuesToCompare])

  const onChangeFetch = (value: string): void => {
    if (myRef.current?.value !== selectedValue?.name) {
      setSelectedValue(null)
    }
    getItems(value)
  }

  const onChangeValueAutocomplete = (value: any): void => {
    myRef.current && (myRef.current.value = value.name)
    setShowValues(false)
    setSelectedValue(value)
  }

  const onPressAdd = (): void => {
    if (
      myrefAmount.current?.value === '' ||
      Number(myrefAmount.current?.value) <= 0 ||
      Number(myrefAmount.current?.value) > 9e9
    ) {
      setShowAmountError(true)
      return
    }

    onChangeValue({
      value: selectedValue,
      amount: myrefAmount.current?.value,
      type: selectedValue?.type,
    })
    setSelectedValue(null)
    myRef.current && (myRef.current.value = '')
    myrefAmount.current && (myrefAmount.current.value = '')

    setShowAmountError(false)
    setShowValues(false)
  }

  return (
    <>
      <div className="col-span-8" ref={myContainerRef}>
        <div className="flex flex-col">
          <label className="font-medium text-primary-900 text-xs dark:text-white mb-1">
            Articulo
          </label>
          <input
            className="dark:bg-gray-600 dark:border-gray-600 h-7 dark:text-white mr-2"
            type="text"
            onFocus={() => setShowValues(true)}
            // onBlur={() => onLeaveInput()}
            // onMouseDown = {() => onLeaveInput()}
            onChange={(e) => onChangeFetch(e.target.value)}
            ref={myRef}
            onKeyPress={(event) => event.key === 'Enter' && onPressAdd()}
          />
        </div>

        {arrayOfValues.length === 0 &&
          myRef.current?.value !== '' &&
          alreadyDone && (
            <p className="text-danger dark:text-danger-dark mt-2">
              Valor incorrecto
            </p>
          )}

        {valueExist && (
          <p className="text-danger dark:text-danger-dark mt-2">
            Valor ya existente
          </p>
        )}

        {arrayOfValues.length > 0 && showValues && (
          <AnimatePresence>
            <motion.div
              className="max-h-40 rounded text-xs px-2 shadow-md absolute bg-white dark:bg-gray-800 z-50 border-gray-100 border-solid border-1 overflow-y-auto lg:w-48 xl:w-96"
              initial="closed"
              animate="open"
              exit="closed"
              // style={{width: 430}}
              transition={{ duration: 0.2, ease: [0.04, 0.62, 0.23, 0.98] }}
              variants={{
                open: { opacity: 1, height: 'max-content' },
                closed: { opacity: 0, height: 60 },
              }}
            >
              {arrayOfValues.map((value, i) => (
                <div
                  key={i}
                  className="cursor-pointer my-1 flex justify-between content-between"
                  onClick={() => onChangeValueAutocomplete(value)}
                >
                  <div className="w-9/12">{value.name}</div>
                  <div className="w-2/4 text-right">
                    {value.barcode || value.sku}
                  </div>
                </div>
              ))}
            </motion.div>
          </AnimatePresence>
        )}
      </div>

      <div className="col-span-3">
        <div className="flex flex-col">
          <label className="font-medium text-primary-900 text-xs dark:text-white mb-1">
            Cantidad
          </label>
          <input
            className="dark:bg-gray-600 dark:border-gray-600 h-7 dark:text-white mr-2"
            type="number"
            ref={myrefAmount}
            onFocus={() => setShowValues(false)}
            min="1"
            onKeyPress={(event) => event.key === 'Enter' && onPressAdd()}
          />

          {showAmountError && (
            <p className="text-danger dark:text-danger-dark mt-2">
              Cantidad inválida
            </p>
          )}
        </div>
      </div>

      {useCase === 'LOAD' && (
      <Tooltip title="Añadir a la carga" position="left">
        <div
          className="col-span-1 mt-4 w-8 h-8 flex justify-center items-center"
          style={{ backgroundColor: '#1A47AA', borderRadius: 5 }}
        >
          <button
            className="border-none p-0"
            disabled={selectedValue === null || arrayOfValues.length === 0}
            onClick={() => onPressAdd()}
          >
            <IoMdAdd size={30} color="white" />
          </button>
        </div>
      </Tooltip>
      )}

      {useCase !== 'LOAD' && (
        <div
        className="col-span-1 mt-4 w-8 h-8 flex justify-center items-center"
        style={{ backgroundColor: '#1A47AA', borderRadius: 5 }}
      >
        <button
          className="border-none p-0"
          disabled={selectedValue === null || arrayOfValues.length === 0}
          onClick={() => onPressAdd()}
        >
          <IoMdAdd size={30} color="white" />
        </button>
      </div>
      )}

    </>
  )
}

interface FieldAutocompleteProps {
  url: string
  bodyGet: string
  queryParam: string
  valuesToCompare?: any[]
  edit?: any
  onChangeValue: (value: any) => void
  useCase:
    | 'COMPOSITION'
    | 'NORMAL'
    | 'LOAD'
    | 'ASSEMBLY'
    | 'UNLOAD'
    | 'RAW_MATERIAL'
  queryParamsId?: string
  isFromAddProduct?: boolean
  secondUrl?: string
  secondQueryParam?: string
  bodyGetSecond?: string
}

export default FieldArrayAutocomplete
